import Vue from "vue";
import Router from "vue-router";
import Home from '@/components/Home.vue';
import SDVereine from '@/components/SDVereine.vue';
import SDBenutzer from '@/components/SDBenutzer.vue';
import SDParaklassen from '@/components/SDParaklassen.vue';
import Sportlerverwaltung from '@/components/Sportlerverwaltung.vue';
import SportlerverwaltungVerein from '@/components/SportlerverwaltungVerein.vue';
import Sportlerfreigaben from '@/components/Sportlerfreigaben.vue';
import Turnieranmeldung from '@/components/Turnieranmeldung.vue';
import TurnieranmeldungExpress from '@/components/TurnieranmeldungExpress.vue';
import PasswortAendern from '@/components/PasswortAendern.vue';
import Benutzerautorisierung from '@/components/Benutzerautorisierung.vue';
import PaareTeams from '@/components/PaareTeams.vue';
import Downloads from '@/components/Downloads.vue';
import TurnieranmeldungVereinUebersicht from '@/components/TurnieranmeldungVereinUebersicht.vue';
import TurnieranmeldungUebersicht from '@/components/TurnieranmeldungUebersicht.vue';
import Etikettendruck from '@/components/Etikettendruck.vue';
import StartsJeKlasse from '@/components/StartsJeKlasse.vue';
import StartsJeVerein from '@/components/StartsJeVerein.vue';
import RouterView from "./components/RouterView.vue"

Vue.use(Router);

export default new Router({
    mode: "history",
    linkExactActiveClass: '',
    linkActiveClass: '',
    base: process.env.BASE_URL,
    component: {
        Home, Sportlerverwaltung, SportlerverwaltungVerein, Sportlerfreigaben, Turnieranmeldung, TurnieranmeldungExpress, TurnieranmeldungVereinUebersicht, TurnieranmeldungUebersicht, SDVereine, SDBenutzer, SDParaklassen, PasswortAendern, Benutzerautorisierung, PaareTeams, Downloads,
        Etikettendruck, RouterView, StartsJeKlasse, StartsJeVerein
    },
    routes: [
        {
            path: '/',
            redirect: '/de/Home'
        },
        {
            path: '/de',
            redirect: '/de/Home'
        },
        {
            path: '/en',
            redirect: '/en/Home'
        },
        {
            path: '/:lang(de,en)?',
            component: {
                render: h => h('router-view')
            },
            children: [
                {
                    path: '/:lang/Home',
                    name: 'Home',
                    component: Home
                },
                {
                    path: '/:lang/Sportlerverwaltung',
                    name: 'Sportlerverwaltung',
                    component: Sportlerverwaltung
                },
                {
                    path: '/:lang/SportlerverwaltungVerein',
                    name: 'SportlerverwaltungVerein',
                    component: SportlerverwaltungVerein
                },
                {
                    path: '/:lang/Sportlerfreigaben',
                    name: 'Sportlerfreigaben',
                    component: Sportlerfreigaben
                },
                {
                    path: '/:lang/Turnieranmeldung',
                    name: 'Turnieranmeldung',
                    component: Turnieranmeldung
                },
                {
                    path: '/:lang/TurnieranmeldungExpress',
                    name: 'TurnieranmeldungExpress',
                    component: TurnieranmeldungExpress
                },
                {
                    path: '/:lang/TurnieranmeldungVereinUebersicht',
                    name: 'TurnieranmeldungVereinUebersicht',
                    component: TurnieranmeldungVereinUebersicht
                },
                {
                    path: '/:lang/TurnieranmeldungUebersicht',
                    name: 'TurnieranmeldungUebersicht',
                    component: TurnieranmeldungUebersicht
                },
                {
                    path: '/:lang/Etikettendruck',
                    name: 'Etikettendruck',
                    component: Etikettendruck
                },
                {
                    path: '/:lang/SDVereine',
                    name: 'SDVereine',
                    component: SDVereine
                },
                {
                    path: '/:lang/SDBenutzer',
                    name: 'SDBenutzer',
                    component: SDBenutzer
                },
                {
                    path: '/:lang/SDParaklassen',
                    name: 'SDParaklassen',
                    component: SDParaklassen
                },
                {
                    path: '/:lang/PasswortAendern',
                    name: 'PasswortAendern',
                    component: PasswortAendern
                },
                {
                    path: '/:lang/Benutzerautorisierung',
                    name: 'Benutzerautorisierung',
                    component: Benutzerautorisierung
                },
                {
                    path: '/:lang/PaareTeams',
                    name: 'PaareTeams',
                    component: PaareTeams
                },
                {
                    path: '/:lang/Downloads',
                    name: 'Downloads',
                    component: Downloads
                },
                {
                    path: '/:lang/StartsJeKlasse',
                    name: 'StartsJeKlasse',
                    component: StartsJeKlasse
                },
                {
                    path: '/:lang/StartsJeVerein',
                    name: 'StartsJeVerein',
                    component: StartsJeVerein
                }
            ]
        }
    ]
});
